//
const letter = document.querySelector('.letter-to-mp div[data-name="letter"]');

//
if (letter != null && typeof letter != 'undefined') {

    //
    const conElection   = letter.getAttribute('data-election');
    const subject       = letter.getAttribute('data-subjuct');

    //
    const sendButton = document.querySelector('.letter-to-mp button[data-name="send-button"]');
    if (sendButton != null) {
        sendButton.disabled = (conElection == 1) ? true : false;
    }

    //set selected row then change name on letter
    if (conElection == 1) {

        document.querySelector('.letter-to-mp tbody[data-name="candidate-table"]').addEventListener('click', (event) => {

            //
            const currentRow = event.target.closest('.letter-to-mp tr[data-name="candidate"]');
            Array.from(currentRow.parentNode.children).forEach(row => {row.classList.remove('selected')});
            currentRow.classList.add('selected');
            sendButton.disabled = false;

            //
            document.querySelector('.letter-to-mp i[data-name="candidate-name"]').innerHTML = `${currentRow.dataset.canname},`;

        });

    }

    //open email in client
    sendButton?.addEventListener('click', (event) => {

        //
        if (sendButton.disabled == true) {
            return;
        }

        //
        const body = encodeURIComponent(letter.innerText);

        //
        let to = (conElection == 0) ? document.querySelector('.letter-to-mp tr[data-name="mp"]').dataset.email : null;

        //
        if ((conElection == 1) && (selectedCandidate = document.querySelector('.letter-to-mp tr[data-name="candidate"].selected')) !=null) {
            to = selectedCandidate.dataset.email;
        }

        //
        if (to != null) {
            window.location.href = `mailto:${to}?subject=${subject}&body=${body}`;
        }

    });

}